import HeaderActions from '@/modules/league/new-components/header/HeaderActions';
import HeaderContent from '@/modules/league/new-components/header/HeaderContent';
import HeaderLeagueButtonsWrapper from '@/modules/league/new-components/header/HeaderLeagueButtons/HeaderLeagueButtonsWrapper';
import NavigationTabs from '@/modules/league/new-components/header/NavigationTabs/NavigationTabs';
import { GameDayInfo } from '@/modules/league/new-components/types';
import { Session } from '@/types/types';

interface PageProps {
  params: { slug: string; sessionId: string; matchDateId: string };
  headerContent: GameDayInfo;
  user?: Session;
  leagueId: string;
  currentSequenceNumber?: number;
  isAuthorized: boolean;
}

const PageLayout = ({
  headerContent,
  params,
  user,
  leagueId,
  currentSequenceNumber,
  isAuthorized,
}: PageProps) => {
  const { details } = headerContent;

  return (
    <>
      <div className='md:[w-834px] mx-auto h-auto w-full overflow-x-hidden bg-leagues-300/10 lg:gap-4 lg:p-[18px_80px]'>
        <div className='mx-auto h-auto w-full max-w-full lg:gap-[24px]'>
          {/* Back to League and All game days */}
          <HeaderLeagueButtonsWrapper {...params} leagueId={leagueId} />
          {/* Title, session and game day info */}
          {headerContent ? <HeaderContent headerContent={headerContent} /> : null}
        </div>
      </div>
      {!details.traditionalLeague && (
        <>
          {!details.isFlexLeague && (
            <HeaderActions
              params={params}
              headerContent={headerContent}
              user={user}
              currentSequenceNumber={currentSequenceNumber}
              isAuthorized={isAuthorized}
            />
          )}
          <div className='md:gap-3pt-11 mx-auto h-auto w-full max-w-screen-xl gap-8 md:flex md:px-3 lg:w-4/5'>
            <NavigationTabs
              isRatingLeagueShowStats={
                headerContent.details.isRatingLeague &&
                headerContent.details.isMatchStarted &&
                headerContent.details.MatchCount >= 1 &&
                headerContent.details.TotalGamesAlreadyPlayed > 0
                  ? true
                  : false
              }
            />
          </div>
        </>
      )}
    </>
  );
};

export default PageLayout;
